import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const SettingsIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z M9.071 4.929H4.93V9.07L2 12l2.929 2.929v4.142H9.07L12 22l2.929-2.929h4.142V14.93L22 12l-2.929-2.929V4.93H14.93L12 2 9.071 4.929ZM4.121 12 6.43 9.693V6.429h3.264L12 4.12l2.307 2.308h3.264v3.264L19.88 12l-2.308 2.307v3.264h-3.264L12 19.88 9.693 17.57H6.429v-3.264L4.12 12Z"
    />
  </IconWrapper>
)

export default SettingsIconMedium
